import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  TicketsActionTypes,
  fetchError,
  fetchSuccess,
  updateSuccess,
  updateError,
  fetchItemSuccess,
  fetchItemError,
  fetchPendingTicketsSuccess,
  fetchPendingTicketsError
  
} from '@actions/ticket';
import ticketApi from '@api/ticket'
import {ReduxAction} from "@actions/index";

function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(ticketApi.getList, payload);
    yield put(fetchSuccess(res));
    
  } catch (err) {
    yield put(fetchError(err.stack!))
  }
}

function* handleFetchPending({payload}: ReduxAction) {
  try {
    const res = yield call(ticketApi.getList, payload);
    yield put(fetchPendingTicketsSuccess(res));
    
  } catch (err) {
    yield put(fetchPendingTicketsError(err))
  }
}

function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(ticketApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  }
  catch (err) {
    yield put(fetchItemError(err))
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(ticketApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data))
  }
  catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* ticketsSaga() {
  yield all([
    yield takeEvery(TicketsActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(TicketsActionTypes.FETCH_PENDING_REQUEST, handleFetchPending),
    yield takeEvery(TicketsActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(TicketsActionTypes.FETCH_ITEM_REQUEST, handleFetchItem)
  ])
}

export default ticketsSaga;
